const defaultSlots =  [
    { label: 'hat', item: undefined, icon: 'hat.webp' },
    { label: 'necklace', item: undefined, icon: 'necklace.webp' },
    { label: 'chest', item: undefined, icon: 'chest.webp' },
    { label: 'left_ring', item: undefined, icon: 'left_ring.webp' },
    { label: 'right_ring', item: undefined, icon: 'right_ring.webp' },
    { label: 'boots', item: undefined, icon: 'boots.webp' },
    { label: 'cape', item: undefined, icon: 'cape.webp' },
    { label: 'epaulettes', item: undefined, icon: 'epaulettes.webp' },
    { label: 'belt', item: undefined, icon: 'belt.webp' },
    { label: 'costum', item: undefined, icon: 'costum.webp' },
    { label: 'left_hand', item: undefined, icon: 'left_hand.webp' },
    { label: 'right_hand', item: undefined, icon: 'right_hand.webp' },
    { label: 'emblem', item: undefined, icon: 'emblem.webp' },
    { label: 'pet', item: undefined, icon: 'pet.webp' },
]

export default defaultSlots;